import services from './services'
export default {
    name: "childAccount",
    data() {
        return {
            dialogVisible: false,
            DataList: []
        }
    },
    props: {
        AgentId: {
            // type:number,
            required: true
        },
    },
    mixins: [services],
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    filters: {
        statusName: function (value) {
            if (value == "已授权登录") {
                return "授权"
            } else {
                return "取消授权"
            }
        }
    },
    methods: {
        showDialog() {
            this.dialogVisible = true;
            this.$nextTick(function () {
                this.getList();
            })
        },
        DialogClose() {
            this.dialogVisible = false;
        },
        accredit(item) {
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                AgentId: item.AgentId,
                Id: item.Id,
            }
            if (item.AuthStatusName === "已授权登录") {
                params.AuthStatus = 2;
            } else {
                params.AuthStatus = 1;
            }
            this.toggleStatus(params)
        },
        empty(item) {
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                AgentId: item.AgentId,
                Id: item.Id,
            }
            this.clearChildImei(params)
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/childAccount/vm.js